import React from 'react'

export function TextError({ children }) {
  return (
    <div className="milan-text-red">
      {children}
    </div>
  )
}

export default TextError